export const ModalContainer = ({ children }) => {
  return (
    <section className="tw-fixed tw-z-[1000] tw-bg-opacity-30 tw-flex tw-justify-center tw-items-center  tw-backdrop-blur-sm tw-inset-0 tw-bg-black ">
      {children}
    </section>
  );
};
